<template>
  <v-container>
    <v-row>
      <v-col stretch>
        <v-breadcrumb :items="breadcrumbCreateItems" :mobile="breadcrumbMobileCreateItem"></v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <v-title-bar :title="$t('signedDocuments.titles.create')">
          <v-button primary @click.native="submitForm()">{{ $t("actions.create") }}</v-button>
        </v-title-bar>
      </v-col>
    </v-row>
    <form @submit.prevent>
      <v-row>
        <v-col class="col-12 md:col-6">
          <v-textfield
            :placeholder="$t('signedDocuments.form.placeholder.title')"
            v-model="title"
            :required="true"
            v-validate="'required'"
            name="title"
            :error="errors.first('title')"
            :data-vv-as="$t('signedDocuments.form.placeholder.title')"
          />
          <div class="form-group">
            <date-picker
              class="envivo-datetimepicker"
              v-model="expireAt"
              :placeholder="$t('signedDocuments.form.placeholder.expire_at')"
              :lang="teams[$route.params.team].account.locale"
              type="datetime"
              confirm
              :formatter="dateTimeFormat"
              :minute-step="1"
              :first-day-of-week="1"
            >
            </date-picker>
          </div>
          <v2-select
            withRequiredLabel
            :placeholder="$t('signedDocuments.form.placeholder.provider')"
            v-model="provider"
            id="provider"
            name="provider"
            optionLabel="label"
            v-validate="'required'"
            :error="errors.first('provider')"
            :data-vv-as="$t('signedDocuments.form.placeholder.provider')"
            :options="providerOptions"
          ></v2-select>
          <v2-select
            withRequiredLabel
            :placeholder="$t('signedDocuments.form.placeholder.preset')"
            v-model="preset"
            id="preset"
            name="preset"
            optionLabel="label"
            v-validate="'required'"
            :error="errors.first('preset')"
            :data-vv-as="$t('signedDocuments.form.placeholder.preset')"
            :options="presetOptions"
          ></v2-select>
          <v2-select
            :placeholder="$t('signedDocuments.form.placeholder.container')"
            v-model="container"
            id="container"
            name="container"
            optionLabel="title"
            :options="containerOptions"
          ></v2-select>
        </v-col>
        <v-col class="col-12">
          <div class="w-full flex justify-end">
            <v-button primary @click.native="submitForm()">{{ $t("actions.create") }}</v-button>
          </div>
        </v-col>
      </v-row>
    </form>
    <v2-uppy-upload
      id="signedDocumentFormUppyModal"
      componentTagname="pdf-only"
      :params="createParams"
      :locale="teams[$route.params.team].account.locale"
      :trigger="null"
      :create-file="createFile"
      :uploadConfig="uploadConfig"
      :openModal="openModal"
      :addEvent="{
        event: 'dashboard:modal-closed',
        method: () => {
          redirectAndReset();
        },
      }"
    ></v2-uppy-upload>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import teamAbilities from "@/mixins/teamAbilities.js";

export default {
  name: "FormSignedDocument",
  mixins: [teamAbilities],
  data() {
    return {
      openModal: false,
      createRequest: this.createSignedDocumentFiles,
      createParams: null,
      uploadConfig: {
        max_files: 1,
      },
      breadcrumbCreateItems: [],
      breadcrumbMobileCreateItem: {
        // label: this.$h.getNameFromProjectsByUid(this.$route.params.uid),
        // route: { name: 'Project', params: { uid: this.$route.params.uid, tab: 'uploads' } }
      },
      submitReady: false,
      dateTimeFormat: {
        stringify: (date) => {
          return date
            ? this.$moment(date).tz(this.teams[this.$route.params.team].account.timezone).format("L HH:mm")
            : null;
        },
        parse: (value) => {
          return value
            ? this.$moment(value, "L HH:mm").tz(this.teams[this.$route.params.team].account.timezone).toDate()
            : null;
        },
      },
      title: "",
      expireAt: new Date(Date.now() + 12096e5),
      provider: null,
      preset: null,
      container: { title: "Default", uid: null },
      providerOptions: [],
      presetOptions: [],
      containerOptions: [],
    };
  },
  created() {
    this.$eventbus.$emit("resetUppy");
    this.getCurrentProject();
    this.setOptions();
    this.preselect();
    this.uploadConfig.max_size = this.teamUploadConfig().max_size;
  },
  methods: {
    ...mapActions(["createSignedDocument", "createSignedDocumentFiles", "getProject"]),
    getCurrentProject() {
      const vm = this;
      vm.getProject({ project: this.$route.params.uid }).then(() => {
        this.breadcrumbCreateItems = [
          {
            label: this.$t("menus.projects"),
            route: { name: "Projects" },
          },
          {
            label: this.currentProject.title,
            route: {
              name: "Project",
              params: { uid: this.currentProject.uid, tab: "uploads" },
            },
          },
          {
            label: this.$t("signedDocuments.menus.create"),
            active: true,
          },
        ];
      });
    },
    createFile(data) {
      const vm = this;
      return new Promise((resolve, reject) => {
        vm.createSignedDocumentFiles(data)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    redirectAndReset() {
      this.openModal = false;
      this.$h.goTo("Project", { uid: this.$route.params.uid, tab: "uploads" });
    },
    setOptions() {
      let obj = this.teams[this.$route.params.team].account.team.attributes.signed_documents.providers;
      Object.keys(obj).forEach((key) => {
        this.providerOptions.push({ label: obj[key].title, value: key });
      });
      obj = this.teams[this.$route.params.team].account.team.attributes.signed_documents.signing_presets;
      Object.keys(obj).forEach((key) => {
        this.presetOptions.push({ label: obj[key].title, value: key });
      });
      this.teams[this.$route.params.team].account.team.attributes.signed_documents.component_container.forEach(
        (container) => {
          this.containerOptions.push(container);
        }
      );
    },
    preselect() {
      this.provider = this.providerOptions[0] ? this.providerOptions[0] : null;
      this.preset = this.presetOptions[0] ? this.presetOptions[0] : null;
    },
    submitForm() {
      const vm = this;
      vm.$validator.validateAll().then((result) => {
        if (result) {
          const data = {
            title: this.title,
            provider: this.provider.value,
            signing_preset: this.preset.value,
            component_container: this.container.uid,
            expected_files_count:
              this.teams[this.$route.params.team].account.team.attributes.signed_documents.signing_presets[
                this.preset.value
              ].expected_files_count,
            expire_at: this.expireAt,
          };
          vm.createSignedDocument({ project: vm.$route.params.uid, data })
            .then(() => {
              vm.$snotify.success(vm.$t("signedDocuments.toasts.create.success"), vm.$t("toasts.success"), {
                icon: vm.$successIcon,
              });
              vm.createParams = {
                project: vm.$route.params.uid,
                document: vm.currentSignedDocument,
              };
              this.uploadConfig.max_files =
                this.teams[this.$route.params.team].account.team.attributes.signed_documents.signing_presets[
                  this.preset.value
                ].expected_files_count;
              this.openModal = true;
            })
            .catch(() => {
              vm.$snotify.error(vm.$t("signedDocuments.toasts.create.error"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
            });
        } else {
          vm.$snotify.error(vm.$t("signedDocuments.toasts.create.validation"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      currentSignedDocument: "signed_documents_get_current_document",
      currentProject: "projects_get_current_project",
      // teamsSettings: 'global_get_teams_settings'
    }),
  },
};
</script>
